// extracted by mini-css-extract-plugin
export var discard = "_2y-3";
export var muiTooltipTooltip = "_2y-5";
export var notificationBar = "_2y-2";
export var saveButtonHoverSlotWrapper = "_2y-4";
export var show = "_2y-1";
export var spacer = "_2y-0";